import React, { Fragment, Component, useState } from 'react';
import './SideBarSearch.scss';
import { SearchContext } from '../../context/SearchContext';
import { facets } from './facets/facetLogic';
import log from 'loglevel';
import { Field } from '../../types/Field';
import {
    Dismiss32Filled as CloseIcon,
    LineHorizontal320Filled as MenuIcon,
    ArrowLeft32Filled as ArrowLeftIcon,
    Search32Filled as SearchIcon,
} from '@fluentui/react-icons';
import { Anchor } from '../common/Anchor';
import FacetFieldCheckboxes from './facets/FacetFieldCheckboxes';
import { Button, Input } from '@fluentui/react-components';
import FacetFilters from './facets/FecetFilters';

interface SideBarSearchProps {
    
}

interface SideBarSearchState {
    isPanelOpen: boolean;
    facetExpanded: string;
}

class SideBarSearch extends Component<SideBarSearchProps, SideBarSearchState> {
    state = {
        isPanelOpen: false,
        facetExpanded: '',
    };

    context!: React.ContextType<typeof SearchContext>;
    static contextType = SearchContext;

    setFacetExpanded = (facetName: string) => this.setState({ facetExpanded: facetName });

    clearSelectedFacet = () => this.setState({ facetExpanded: '' });

    renderSelectedFacet = (allFacetsField: any) => {
        if (!allFacetsField || !this.state.facetExpanded) return;

        const faceData = allFacetsField.filter((el: any) => el.name === this.state.facetExpanded)[0].name;
        return faceData;
    };

    clearGroupFilter = (facetName: string, values: string) => {        
        let valueChanged = '';

        if(facetName === "Locations") {
            valueChanged = JSON.parse(values);
            this.facetChanged(facetName, valueChanged);
        } else if (values.indexOf(',') === -1) {
            valueChanged = values.trim();
            this.facetChanged(facetName, valueChanged);
        } else {
            let valuesArr = values.split(', ');
            valuesArr.forEach((element) => {
                valueChanged = element;
                this.facetChanged(facetName, valueChanged);
            });
        }
    };

    facetChanged = (facetName: string, valueChanged: any) => {

        if (this.context.filterableUIFields === undefined || this.context.filterableUIFields.length === 0) {
            log.error('[facetChanged] No filterable UI fields found in the context.');
            return;
        }

        // Find the corresponding facet configuration by the name of the facet.
        const field = this.context.filterableUIFields.find((f) => f.name === facetName);
        if (!field) {
            log.error(`[facetChanged] No field found for facet name: ${facetName}`);
            return;
        }

        const facetLogic = facets.getFacetLogicByType(field.systemSettings.type);
        if (!facetLogic) {
            log.error(`[facetChanged] Unexpected data type found: ${field.systemSettings.type}`);
            return;
        }

        this.context.updateFacetSelection(facetName, valueChanged, facetLogic.createUpdatedSelection);
    };
    handleOpenFilter = () => {
        this.setState((prevState) => ({ isPanelOpen: !prevState.isPanelOpen }));
    };
    renderFacets = (fields: Field[], facetValues: any, facetSelections: any) => {
        if (!fields || fields.length === 0 || !facetValues || !facetSelections) {
            return null;
        }

        let renderedOutput: any[] = [];

        // The facets are rendered in the order they are returned in the facet configuration retrieved once from the back-end.
        fields.forEach((field) => {
            let facetValue = facetValues[field.name];
            let facetSelection = facetSelections[field.name];

            if (!field.userSettings.showInFacetArea) {
                return;
            }

            const facetLogic = facets.getFacetLogicByType(field.systemSettings.type);
            if (!facetLogic) {
                log.error(`[renderFacets] Unexpected data type found: ${field.systemSettings.type}`);
                return;
            }

            renderedOutput.push(facetLogic.renderFacet(field, facetValue, facetSelection, this.facetChanged, this.setFacetExpanded));
        });

        return renderedOutput;
    };

    getFecetFilterData = (facetSelections: any) => {
       
        let filterDataArr: any[] = [];

        let facetSelectedKeys = Object.keys(facetSelections);
        facetSelectedKeys.forEach((element) => {
            let filterDataJson = {
                key: '',
                values: [],
                name: '',
            };

            if (element !== 'TimeStart' && element !== 'Duration') {
                 if (this.context.filterableUIFields === undefined || this.context.filterableUIFields.length === 0) {
                    throw new Error('[getFecetFilterData] No filterable UI fields found in the context.');
                }

                const field = this.context.filterableUIFields.find((f) => f.name === element);
                if (!field) {
                    log.error(`[getFecetFilterData] No field found for facet name: ${element}`);
                    return;
                }

                filterDataJson.key = field.systemSettings.displayName;
                filterDataJson.values = facetSelections[element];
                filterDataJson.name = field.name;

                filterDataArr.push(filterDataJson);
            }
        });

        return filterDataArr;
    };

    render() {
        if(this.context.filterableUIFields === undefined)
            return;
        
        let filters = this.context.filterableUIFields;
        let selectedFilterData = this.getFecetFilterData(this.context.facetSelections);

        // The facets are rendered based upon the configuration retrieved once from the API and the current search results.
        const renderedFacets = this.renderFacets(filters, this.context.facetValues, this.context.facetSelections);
        const selectedFacets = this.renderSelectedFacet(filters);
        const facetData = this.context.facetValues[selectedFacets];
        const facetSelection = this.context.facetSelections[this.state.facetExpanded];

        const { isPanelOpen } = this.state;
        return (
            <Fragment>
                {selectedFilterData.length !== 0 && (
                    <div className="side-header">
                        
                            <header className="wrapper-header display--flex">
                                <p className="title">Selected Filters</p>
                                <Anchor
                                    className="clear-filter-hl"
                                    onClick={() => {
                                        localStorage.removeItem('facetSelections');
                                        this.context.updateSearchQuery(this.context.searchSettings.query, undefined);
                                    }}
                                >
                                    Clear all filters
                                </Anchor>
                                <div className="support-dropdown-menu">
                                    <Button appearance="transparent" onClick={this.handleOpenFilter} icon={isPanelOpen ? <CloseIcon /> : <MenuIcon />} />
                                </div>
                            </header>
                        
                    </div>
                )}
                <div className={`selected-filters ${selectedFilterData.length > 3 && 'selected-filters-height'}`}>
                    <FacetFilters filterData={selectedFilterData} clearGroupFilter={this.clearGroupFilter} />
                </div>
                {selectedFilterData.length !== 0 && <hr className={`hr-rounded ${isPanelOpen && 'hr-rounded-show'} ${!isPanelOpen && 'hr-rounded-hide'}`}/>}
                <div className={`support-bar ${selectedFilterData.length > 0 && 'support-bar-with-filter-height'}`}>
                    <section className={`support-search ${isPanelOpen && 'active'}`}>
                        {!this.state.facetExpanded ? (
                            renderedFacets
                        ) : (
                            <StringFacetFieldFilters
                                clearSelectedFacet={this.clearSelectedFacet}
                                name={selectedFacets}
                                facetData={facetData}
                                onChangeFacet={this.facetChanged}
                                facetSelection={facetSelection || []}
                            />
                        )}
                    </section>
                </div>
            </Fragment>
        );
    }
}

export default SideBarSearch;

interface StringFacetFieldFiltersProps {
    clearSelectedFacet: () => void;
    name: string;
    facetData: Record<string, any>;
    onChangeFacet: (facetName: string, valueChanged: any) => void;
    facetSelection: any[];
}

const StringFacetFieldFilters: React.FC<StringFacetFieldFiltersProps> = ({ clearSelectedFacet, name, facetData, onChangeFacet, facetSelection }) => {
    const [term, setTerm] = useState('');

    const filterFacetData = Object.keys(facetData).filter((el) => el.toLowerCase().includes(term.toLowerCase()));
    const filtredData = filterFacetData.reduce((acc, el) => ({ ...acc, [el]: facetData[el] }), {});

    return (
        <div>
            <ArrowLeftIcon onClick={clearSelectedFacet} style={{ marginBottom: 20 }} />
            <h3 style={{ marginTop: 0 }}>{name}</h3>
            <Input
                contentAfter={<SearchIcon />}
                value={term}                
                placeholder="Search..."
                onChange={(e) => setTerm(e.target.value === undefined ? '' : e.target.value)}
            />
            <ul style={{ margin: '10px 0px' }}>
                {!filterFacetData.length ? (
                    'Sorry, there are no filters available for your search'
                ) : (
                    <FacetFieldCheckboxes facetData={filtredData} onChangeFacet={onChangeFacet} name={name} facetSelection={facetSelection} />
                )}
            </ul>
        </div>
    );
};
